import INVENTORY_API_BASE_URL from "../../config/api";
import React, { useState, useEffect } from "react";
import Axios from "axios";
import Table from "react-bootstrap/Table";
import "./ReturnLabel.css";
import { useRef } from "react";
import Barcode from "react-barcode";
import { useReactToPrint } from "react-to-print";

function ReturnLabel() {
  const [data, setData] = useState([]);
  const [showEmptyTable, setShowEmptyTable] = useState(false);
  const [generatedRows, setGeneratedRows] = useState([]);
  const [barcodeStrings, setBarcodeStrings] = useState([]);
  const [selectedOrderSeq, setSelectedOrderSeq] = useState(null);
  const [selectedDistributor, setSelectedDistributor] = useState(null);

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  useEffect(() => {
    Axios.get(`${INVENTORY_API_BASE_URL}/getManagereturn`).then((response) => {
      const reversedData = response.data.reverse();
      setData(reversedData);
    });
  }, []);

  const handleGenerateClick = (rowIndex, inputValue, sku, OrderSeq, title) => {
    const entryForSKU = data[rowIndex].Entries.find(
      (entry) => entry.SKU === sku
    );

    if (entryForSKU) {
      const generatedRowArray = Array.from(
        { length: inputValue },
        (_, index) => ({
          rowNumber: index + 1,
          sku,
          OrderSeq,
          title,
          medium: entryForSKU.Medium, 
        })
      );

      const newBarcodeStrings = generatedRowArray.map(
        (rowData) => rowData.sku + rowData.OrderSeq + "R" + rowData.rowNumber
      );

      setGeneratedRows((prevGeneratedRows) => [
        ...prevGeneratedRows,
        ...generatedRowArray,
      ]);
      setBarcodeStrings((prevBarcodeStrings) => [
        ...prevBarcodeStrings,
        ...newBarcodeStrings,
      ]);
      setShowEmptyTable(true);
    }
  };

  return (
    <div className="ReturnLabelmain">
      <h4 className="ReturnLabel">Generate Label</h4>
      <Table responsive className="returnlabeltable">
        <thead>
          <tr>
            <th>GRN Number</th>
            <th>Distributor Name</th>
            <th>SKU</th>
            <th>Title</th>
            <th>Edition</th>
            <th>Medium</th>
            <th>Total Quantity</th>
            <th>Enter Quantity</th>
            <th>Generate Label</th>
          </tr>
        </thead>
        <tbody>
          {data.map((row, rowIndex) => (
            <React.Fragment key={rowIndex}>
              <tr>
                <td colSpan="9">
                  <button
                    onClick={() => {
                      setSelectedOrderSeq(row.OrderSeq);
                      setSelectedDistributor(row.Distributor);
                    }}
                    type="button"
                    className="btn btn-primary"
                  >
                    {row.OrderSeq} {row.Distributor}
                  </button>
                </td>
              </tr>
              {selectedOrderSeq === row.OrderSeq &&
                selectedDistributor === row.Distributor &&
                row.Entries.map((entry, entryIndex) => (
                  <RowInput
                    key={entryIndex}
                    OrderSeq={row.OrderSeq}
                    distributor={row.Distributor}
                    sku={entry.SKU}
                    title={entry.Title}
                    edition={entry.Edition}
                    medium={entry.Medium}
                    quantity={entry.Return_Quantity}
                    onGenerateClick={(inputValue, sku, OrderSeq, title) =>
                      handleGenerateClick(
                        rowIndex,
                        inputValue,
                        sku,
                        OrderSeq,
                        title
                      )
                    }
                  />
                ))}
            </React.Fragment>
          ))}
        </tbody>
      </Table>
      {showEmptyTable && (
        <div ref={componentRef}>
          <div className="barcodeContainer">
            {barcodeStrings.map((barcode, index) => {
              const rowData = generatedRows[index];
              return (
                <div key={index} className="barcode-item">
                  <p className="barcodeT">{rowData.title.substring(0, 30)}</p>
                  <p className="barcodeM">{rowData.medium}</p>

                  <Barcode
                    height="26rem"
                    width="1rem"
                    fontSize="11px"
                    marginLeft="2rem"
                    value={barcode}
                  />
                </div>
              );
            })}
          </div>
        </div>
      )}
      <br />

      <button
        style={{ marginLeft: "22rem", marginBottom: "8rem" }}
        type="button"
        className="btn btn-primary"
        onClick={handlePrint}
      >
        Print Barcodes
      </button>
    </div>
  );
}

function RowInput({
  OrderSeq,
  distributor,
  sku,
  title,
  edition,
  medium,
  quantity,
  onGenerateClick,
}) {
  const [inputValue, setInputValue] = useState(quantity);

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  return (
    <tr>
      <td>{OrderSeq}</td>
      <td>{distributor}</td>
      <td>{sku}</td>
      <td>{title}</td>
      <td>{edition}</td>
      <td>{medium}</td>
      <td>{quantity}</td>
      <td>
        <input
          type="number"
          value={inputValue}
          onChange={handleInputChange}
        />
        onWheel={(e) => e.target.blur()}
      </td>
      <td>
        <button
          onClick={() => onGenerateClick(inputValue, sku, OrderSeq, title)}
          type="button"
          className="btn btn-primary"
        >
          Generate
        </button>
      </td>
    </tr>
  );
}

export default ReturnLabel;
